export default __webpack_public_path__ + "static/media/2366.1801945f.png";